import { BaseModel } from "./base-model"

export class Color {
  public id: string
  public type: string
  public code: string
  public createdAt: Date
  public updatedAt: Date

  constructor() {
    this.id = null
    this.type = null
    this.code = "#445e77"
    this.createdAt = new Date()
    this.updatedAt = new Date()
	}
}